<template>
  <svg :x="`${svg.x}%`" :y="`${svg.y}%`" :width="`${svg.width}%`" :height="`${svg.height}%`">

    <!-- debugger
    <rect x="0" y="0" width="100%" height="100%" style="stroke:green; stroke-width:1; fill:none;"/>
    -->

    <!--
    <defs>
      <filter x="0" y="0" width="1" height="1" id="svg-line-point-text">
        <feFlood flood-color="white"/>
        <feComposite in="SourceGraphic" operator="over" />
      </filter>
    </defs>
    -->

    <defs>
      <filter x="-10%" y="-10%" width="120%" height="120%" filterUnits="objectBoundingBox" id="svg-line-point-text">
        <feFlood flood-color="white" flood-opacity=".6" result="FLOOD" />
        <feMerge>
          <feMergeNode in="FLOOD" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    <!--
    SVG с искожаемым контентом при измении соотношения сторон
    тут размещаем график. Если меток не нужно то этот SVG можно сделать родительским
    -->
    <svg x="0" y="0" width="100%" height="100%"
      :viewBox="`${viewBox.x} ${viewBox.y} ${viewBox.width} ${viewBox.height}`"
      preserveAspectRatio="none" class="">
      <!-- debugger
      <rect x="0" y="0" width="100%" height="100%" style="stroke:red; stroke-width:1; fill:none;"/>
      -->
      <!-- график -->
      <polyline :points="points" :stroke="data.style.color"
        stroke-width="2" fill="none" stroke-linejoin="round"/>
    </svg>

    <!-- Метки, круги позиционируемые по %, их форма не искажается при изменении соотношения сторон -->
    <g v-if="circles.length > 0">
      <circle v-for="(circle, index) in circles" :key="index"
        :cx="`${circle.x}%`" :cy="`${circle.y}%`" :r="circle.r" :stroke="data.style.color"
        stroke-width="2" fill="white"/>
    </g>

    <!-- Метки над кругами позиционируемые по %, их форма не искажается при изменении соотношения сторон -->
    <g v-if="pLabels.length > 0">
      <text filter="url(#svg-line-point-text)" v-for="(pLabel, index) in pLabels" :key="index" class="pointLabel"
        :x="`${pLabel.x}%`" :y="`${pLabel.y}%`" fill="black">
        <tspan dy="-14px">{{ pLabel.label }}</tspan>
      </text>
    </g>

    <!-- Пример текстовых меток
    <text v-for="(label, index) in labels" :key="index + 100" :x="`${label.x}%`" :y="`${label.y}%`"
      text-anchor="middle">
      {{ label.text }}
    </text>
    -->

  </svg>
</template>

<script>
export default {
  inject: ['getSvg', 'getViewBox', 'childDataUpdated'],
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          series: [],
          style: {
            color: '#ffffff',
            strokeWidth: 1
          },
          pointsLabels: null // Значения рисуемые над точками плоскости
        }
      }
    }
  },
  data () {
    return {
      points: [],
      circles: [],
      labels: [],
      pLabels: []
    }
  },
  computed: {
    viewBox () {
      return this.getViewBox()
    },
    svg () {
      return this.getSvg()
    }
  },
  watch: {
    data (_new, _old) {
      this.childDataUpdated()
    }
  },
  methods: {
    getDomainRange () {
      const domainRange = {
        xDRange: { min: Math.min(...this.data.series.map(d => d.x)), max: Math.max(...this.data.series.map(d => d.x)), absolute: true },
        yDRange: { min: Math.min(...this.data.series.map(d => d.y)), max: Math.max(...this.data.series.map(d => d.y)), absolute: true }
      }
      return domainRange
    },
    render (mappers) {
      this.points = this.data.series.map(({ x, y }) => ({
        x: mappers.real.x(x),
        y: mappers.real.y(y)
      }))
        .filter(({ x, y }) => x !== null)
        .map(({ x, y }) => `${x}, ${y}`)
        .join(' ')

      this.circles = this.data.series.map(({ x, y }) => ({
        x: mappers.percent.x(x),
        y: mappers.percent.y(y),
        r: 3
      })).filter(({ x, y }) => x !== null)

      this.pLabels = Array.isArray(this.data.pointsLabels)
        ? this.data.pointsLabels.map(({ x, y, label }) => ({
          x: mappers.percent.x(x),
          y: mappers.percent.y(y),
          r: 3,
          label: label
        })).filter(({ x, y }) => x !== null)
        : []

      // Пример текстовых меток
      // this.labels = this.data.series.map(({ x, y }) => {
      //  return { x: mappers.percent.x(x), y: mappers.percent.y(y), text: y }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
svg * {
  overflow: visible;
  vector-effect: non-scaling-stroke;
}
.pointLabel {
  text-anchor: middle;
}
</style>
